import styled from '@emotion/styled'

import Button from '../../../../components/Button'
import { MOBILE } from '../../../../guided-toolbox/utils/breakpoints'
import { IconButton, RemoveIcon, SectionBox } from '../../styled'
import SecurityDetails from './SecurityDetails'

const Box = styled(SectionBox)`
  padding: 0px 30px 25px;

  ${MOBILE} {
    padding: ${p => (p.spellsOutChange ? '0px 20px 20px' : '0px 14px 30px')};
  }
`

const ClearButton = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
`

/* Design: sits 20px clear of the investment type above it and fills the box. */
const ChangeButton = styled(Button)`
  margin-top: 20px;
`

/**
 * The investment the user picked, with whatever hands the search back to them.
 *
 * Desktop gets the X in the corner. Where the flow has a screen to itself, an X in the corner of a
 * box reads as "dismiss this box", so the way back is spelled out as a button instead. Editing an
 * investment offers neither: the investment is not up for changing there.
 *
 * @param {Object} props
 * @param {Object} props.security
 * @param {Function} [props.onClear] shows the corner X, which drops the chosen investment
 * @param {Function} [props.onChange] shows the "Change investment" button
 */
const SelectedSecurity = props => {
  const { security, onClear, onChange } = props

  return (
    <Box spellsOutChange={Boolean(onChange)}>
      {onClear && (
        <ClearButton>
          <IconButton type='button' aria-label='Clear selected investment' onClick={onClear}>
            <RemoveIcon />
          </IconButton>
        </ClearButton>
      )}

      <SecurityDetails security={security} clearsIcon={Boolean(onClear)} />

      {onChange && (
        <ChangeButton
          type='button'
          variant='secondary'
          size='xsmall'
          width='100%'
          onClick={onChange}>
          Change investment
        </ChangeButton>
      )}
    </Box>
  )
}

export default SelectedSecurity
